import dayjs from "dayjs";
import { ISO_DATE } from "../../utils/dates";
import { object, string } from "yup";
import { PropertyField } from "./PropertyField";
import get from "lodash/get";

const formatters = {
    date: property => property?.value ? dayjs(property.value).toDate() : "",
    default: property => property?.value || ""
};

const parsers = {
    date: property => value => value ? ({ uuid: property.uuid, label: property.label, value: dayjs(value).format(ISO_DATE) }) : null,
    default: property => value => value ? ({ uuid: property.uuid, label: property.label, value }) : null
};

export const createPropertyField = (property, basePath = "properties", fullWidth = false) => {
    const field = {
        name: `${basePath}.${property.uuid}`,
        label: property.label,
        type: property.type,
        format: formatters[property.type] || formatters.default,
        parse: (parsers[property.type] || parsers.default)(property)
    };
    if (!fullWidth) field.width = property.type === "date" ? 200 : 300;
    if (property.type === "select") field.options = [{ label: "", value: null }, ...property.config.options.map(value => ({ label: value, value }))];
    if (property.required) field.validation = object().shape({ value: string().required("Required") }).nullable().required("Required");

    return field;
};

export const createPropertyFieldForRegistration = (property, basePath = "properties", fullWidth = false, entry, athlete, contactEmail) => {
    const field = createPropertyField(property, basePath, fullWidth);
    const config = property.config;

    if (config) {
        if (config.validation?.url){
            field.property = property;
            field.params = entry;
            field.component = PropertyField;
        }

        if (config.restricted && property.level === "athlete" && get(athlete, `properties.${property.uuid}.value`) !== undefined ) {
            field.inputProps = {
                disabled: true,
                "aria-disabled": true
            };
            field.restricted = true;
            field.contactEmail = contactEmail;
        }
    }

    return field;
};

export const shouldDisplayField = values => property => {
    const compare = condition => {
        if (condition.comparator === "greater") return get(values, condition.property) > condition.value;
        if (condition.comparator === "less") return get(values, condition.property) < condition.value;
        if (condition.comparator === "equal") return get(values, condition.property) == condition.value; // eslint-disable-line eqeqeq
        if (condition.comparator === "notequal") return !!get(values, condition.property) && get(values, condition.property) != condition.value; // eslint-disable-line eqeqeq
    };

    if (!property.config?.requireIf) return true;

    return property.config.requireIf.conditions.reduce((result, condition) => {
        if (property.config.requireIf.operator === "and") return result && compare(condition);
        else if (property.config.requireIf.operator === "or") return result || compare(condition);
        else return compare(condition);
    }, property.config.requireIf.operator === "and");
};
